import { createBrowserRouter } from "react-router-dom";
import { PublicLayout } from "../Layout/PublicLayout";
import HeroSlider from "../Components/HeroSlider";
import Contact from "../Pages/Contact";
import WishList from "../Pages/WishList";
import AddToCart from "../Pages/AddToCart";
import Login from "../Pages/Login";
import AllProductsList from "../Components/AllProductsList";
import ProductDetails from "../Pages/ProductDetails";
import GetProductDetails from "../Pages/GetProductDetails";
import Page404 from "../Pages/Page404/Page404";
import CreateAccount from "../Pages/CreateAccount";
import Invoice from "../Pages/Invoice";
import Layout from "../Layout/Layout";
import { PrivateRoute } from "./ProtectedRoutes";
import routes from "./Routes";
import Videos from "../Pages/Videos";
import Blog from "../Pages/Blog";

const router = createBrowserRouter([
    {
        path: "/",
        element: <PublicLayout />,
        children: [
            { path: "/", element: <HeroSlider /> },
            { path: "/AllProductsList/:category_id", element: <AllProductsList /> },
            { path: "/AllProductsList", element: <AllProductsList /> },
            { path: "/ProductDetails/:product_id", element: <ProductDetails /> },
            { path: "/GetProductDetails/:product_id", element: <GetProductDetails /> },
            { path: "/AddToCart", element: <AddToCart /> },
            { path: "/WishList", element: <WishList /> },
            { path: "/Contact", element: <Contact /> },
            { path: "/Videos", element: <Videos /> },
            { path: "/Blog", element: <Blog /> },
            { path: "*", element: <Page404 /> },
        ]
    },
    {
        path: "/Login",
        element: <Login />,
    },
    { path: "/CreateAccount", element: <CreateAccount /> },
    { path: "/Invoice/:order_id", element: <Invoice /> },
    {
        path: "/",
        element: <Layout />,
        children: [
            ...routes.map((route) => ({
                ...route,
                element: <PrivateRoute element={route.element} />,
            })),
            { path: "*", element: <Page404 /> },
        ],
    },
]);

export default router;